import { Pipe, PipeTransform } from '@angular/core';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';

@Pipe({
   name: 'directoryColumnHeaderIsSearchable',
})
export class DirectoryColumnHeaderIsSearchablePipe implements PipeTransform {
   transform(directoryColumn: DirectoryColumn, searchableColumns: DirectoryColumn[] | Observable<DirectoryColumn[]>): unknown {
      let searchableColumns$: Observable<DirectoryColumn[]>;
      if (isObservable(searchableColumns)) {
         searchableColumns$ = searchableColumns;
      } else {
         searchableColumns$ = of(searchableColumns);
      }
      return searchableColumns$.pipe(map((searchableColumn) => searchableColumn?.includes(directoryColumn) ?? false));
   }
}
